import React, { useState, createContext } from "react";
import { useNavigate } from "react-router-dom";
import { apiGetEventById, apiGetCurrentUser } from '../api/api'

export const EventContext = createContext()

export const EventProvider = (props) => {
    let navigate = useNavigate()
    const [eventData, setEventData] = useState(
        {
            "_id": "",
            "name": "Loading....",
            "status": "",
            "description": "",
            "dateTime": "",
            "location": "",
            "contact": "",
            "link": "",
            "price": "",
            "organizer": "",
            "numberOfBookmark": 0,
            "createdAt": "",
            "updatedAt": ""
        }
    )
    const [isLoaded, setIsLoaded] = useState(false)
    const [userData, setUserData] = useState(
        {
            "email": "",
            "isOrganizer": false,
            "eventEnrolled": []
        }
    )

	const isOrganizer = (user, event) => {
		return user.email === event.organizer
	}

    const fetchEventData = async (id) => {
        let res_event = await apiGetEventById(id)
        let res_user = await apiGetCurrentUser()
        res_event = res_event.data.content
        res_user = res_user.data.user
        console.log("event", res_event)
        console.log("user", res_user.eventEnrolled)
        setEventData(res_event)
        setUserData(
            {
                "email": res_user.email,
                "isOrganizer": isOrganizer(res_user, res_event),
                "eventEnrolled": res_user.eventEnrolled
            }
        )
        setIsLoaded(true)
    }

	const data = {
		eventData,
		setEventData,
		isLoaded,
		setIsLoaded,
		userData,
		setUserData,
		fetchEventData
	}


	return (
		<EventContext.Provider value={data}>
				{props.children}
		</EventContext.Provider>
	)
}
